import styled from 'styled-components';

const EmailSubscribeFormContainer = styled.div`
  display: flex;
  width: 100%;

  .subscribe-form {
    box-shadow: none !important;
    max-width: 490px;
    width: 100%;
  }

  .data-layer-form {
    margin-left: 3px;
  }

  .signup-form--container {
    margin-left: -100px !important;
  }

  .signup-form--form .ant-form-item button {
    height: 61px;
    min-width: 0;
    font-weight: bold;
    padding: 15px 24px;
    box-shadow: 0 3px 6px 1px rgba(160, 161, 188, 0.35);

    &:hover {
      box-shadow: none;
    }
  }

  .slick-list {
    height: max-content !important;
  }

  .form-field {
    flex-grow: 1;
    margin-right: 16px !important;

    .text-field-wrapper {
      input {
        height: 62px !important;
        box-shadow: 0 3px 6px 1px rgba(160, 161, 188, 0.35);
        width: 100%;
      }
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;

    .subscribe-form {
      padding: 0;
      width: 100%;
    }

    .data-layer-form {
      width: 100% !important;
    }

    .text-field-wrapper .text-field-input {
      height: 55px !important;
    }

    button {
      font-size: 18px;
      line-height: 31px;
      padding: 12px 24px;
      width: 100%;
      margin-left: 0;
    }
  }
`;

export { EmailSubscribeFormContainer };
